import { filter, switchMap, map, startWith, first } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, Inject, NgModule } from '@angular/core';
import { combineLatest, of } from 'rxjs';
import * as i4 from '@play/common';
import { ExpansionState, CommonsLoadingModule, CommonsComponentModule, CommonsDateModule, CommonsErrorModule } from '@play/common';
import { getUser, entryAvailable, LoadContestantsOnceAction, getContestants, LoadMediaOnceAction, LoadLeagueOnceAction, getLeague, distinct, LoadLeagueResultsAction, getLeagueResults, exists, LoadMatchOnceAction, getMatch, LoadPubgMatchSettingsOnceAction, getPubgMatchSettings, LoadPlayersOnceAction, getPlayer, LoadTeamsOnceAction, getTeam, LoadRosterOnceAction, LoadMembersOnceAction, getTeamMembers, getRoster, StateModule } from '@play/state';
import * as i1$1 from '@ngrx/store';
import { find, reduce, sortBy } from 'lodash';
import * as i2$2 from '@play/ranking/ffa';
import { MATCH_METADATA, RANKING_MEMBER_TEXTS, FFArankingModule } from '@play/ranking/ffa';
import { hasIntegration, isTeam, isRosterEnabled, isPlayer } from '@play/utility/league';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2$1 from '@play/match/media';
import { MatchMediaModule } from '@play/match/media';
import * as i1 from '@play/match';
import { MatchModule } from '@play/match';
import * as i2 from '@play/translate';
import { TranslationModule } from '@play/translate';
import * as i3 from '@play/ranking';
import { RankingComponentsModule } from '@play/ranking';

class MatchContestantService {
    constructor(linkService) {
        this.linkService = linkService;
    }
    getRankedContestant(matchId, contestant, results) {
        let rank = 0;
        let points = 0;
        let tiebreaker = 0;
        const result = find(results, match => match.id === matchId);
        const participant = find(result ? result.participants : [], cont => cont.id === contestant.id);
        if (participant) {
            rank = participant.place ? participant.place : rank;
            points = reduce(participant.points, (sum, point) => {
                return sum + point;
            }, 0);
            tiebreaker = reduce(participant.tiebreaker, (sum, point) => {
                return sum + point;
            }, 0);
        }
        return Object.assign(Object.assign({}, contestant), { rank: rank, points: points, tiebreaker: tiebreaker });
    }
}
MatchContestantService.ɵfac = function MatchContestantService_Factory(t) { return new (t || MatchContestantService)(i0.ɵɵinject(i4.LinkService)); };
MatchContestantService.ɵprov = i0.ɵɵdefineInjectable({ token: MatchContestantService, factory: MatchContestantService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchContestantService, [{
        type: Injectable
    }], function () { return [{ type: i4.LinkService }]; }, null); })();

const _c0$3 = function (a0) { return { number: a0 }; };
const _c1$2 = function (a0) { return { round: a0 }; };
const _c2$2 = function (a0) { return { group: a0 }; };
class FFAMatchInformationComponent {
}
FFAMatchInformationComponent.ɵfac = function FFAMatchInformationComponent_Factory(t) { return new (t || FFAMatchInformationComponent)(); };
FFAMatchInformationComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FFAMatchInformationComponent, selectors: [["ffa-match-information"]], inputs: { startTime: "startTime", state: "state", position: "position", round: "round", group: "group" }, decls: 10, vars: 20, consts: [[1, "c-match-information--pubg", 3, "state", "startTime"], [1, "u-color-saturated"]], template: function FFAMatchInformationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "match-information", 0);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementStart(3, "small", 1);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(6, " \u2013 ");
        i0.ɵɵelementStart(7, "small", 1);
        i0.ɵɵtext(8);
        i0.ɵɵpipe(9, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("state", ctx.state)("startTime", ctx.startTime);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 5, "ffa-match:match-number", i0.ɵɵpureFunction1(14, _c0$3, ctx.position)), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(5, 8, "ffa-match:round", i0.ɵɵpureFunction1(16, _c1$2, ctx.round)));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(9, 11, "ffa-match:group", i0.ɵɵpureFunction1(18, _c2$2, ctx.group + 1)));
    } }, directives: [i1.MatchInformationComponent], pipes: [i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAMatchInformationComponent, [{
        type: Component,
        args: [{
                selector: "ffa-match-information",
                templateUrl: "./ffa-match-information.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { startTime: [{
            type: Input
        }], state: [{
            type: Input
        }], position: [{
            type: Input
        }], round: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

function FFAMatchInformationPubgComponent_div_35_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "ffa-match-information-pubg:lobby-name"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(": ", ctx_r1.lobbyName, " ");
} }
function FFAMatchInformationPubgComponent_div_35_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementStart(5, "play-button", 16);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "ffa-match-information-pubg:lobby-password"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(": ", ctx_r2.lobbyPassword, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("copyToClipboard", ctx_r2.lobbyPassword);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, "commons:copy"), " ");
} }
function FFAMatchInformationPubgComponent_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, FFAMatchInformationPubgComponent_div_35_div_1_Template, 5, 4, "div", 12);
    i0.ɵɵtemplate(2, FFAMatchInformationPubgComponent_div_35_div_2_Template, 8, 8, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.lobbyName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.lobbyPassword);
} }
const _c0$2 = function (a0, a1) { return { "u-color-saturated": a0, "u-color-failure": a1 }; };
const _c1$1 = function (a0) { return { enabled: a0 }; };
const _c2$1 = function (a0) { return { number: a0 }; };
const _c3$1 = function (a0) { return { round: a0 }; };
const _c4 = function (a0) { return { group: a0 }; };
class FFAMatchInformationPubgComponent extends FFAMatchInformationComponent {
}
FFAMatchInformationPubgComponent.ɵfac = function FFAMatchInformationPubgComponent_Factory(t) { return ɵFFAMatchInformationPubgComponent_BaseFactory(t || FFAMatchInformationPubgComponent); };
FFAMatchInformationPubgComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FFAMatchInformationPubgComponent, selectors: [["ffa-match-information-pubg"]], inputs: { mode: "mode", weather: "weather", redzoneEnabled: "redzoneEnabled", lobbyName: "lobbyName", lobbyPassword: "lobbyPassword" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 45, vars: 61, consts: [[1, "c-match-information--pubg", 3, "state", "startTime"], [1, "o-grid", "o-grid--inside"], [1, "o-grid__item", "u-1/3", "u-baseline"], [1, "o-flag"], [1, "o-flag__figure", "u-color-saturated"], [3, "icon"], [1, "o-flag__body"], [1, "o-flag__figure"], [3, "ngClass", "icon"], ["class", "c-match-information--pubg__loby u-baseline", 4, "ngIf"], [1, "u-color-saturated"], [1, "c-match-information--pubg__loby", "u-baseline"], ["class", "c-match-information--pubg__lobby__name", 4, "ngIf"], ["class", "c-match-information--pubg__lobby__password", 4, "ngIf"], [1, "c-match-information--pubg__lobby__name"], [1, "c-match-information--pubg__lobby__password"], ["type", "'flat'", 1, "c-flat-button--primary", 3, "copyToClipboard"]], template: function FFAMatchInformationPubgComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "match-information", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelement(5, "svg-icon", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelementStart(7, "div");
        i0.ɵɵelementStart(8, "strong");
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 2);
        i0.ɵɵelementStart(14, "div", 3);
        i0.ɵɵelementStart(15, "div", 4);
        i0.ɵɵelement(16, "svg-icon", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 6);
        i0.ɵɵelementStart(18, "div");
        i0.ɵɵelementStart(19, "strong");
        i0.ɵɵtext(20);
        i0.ɵɵpipe(21, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(22);
        i0.ɵɵpipe(23, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 2);
        i0.ɵɵelementStart(25, "div", 3);
        i0.ɵɵelementStart(26, "div", 7);
        i0.ɵɵelement(27, "svg-icon", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 6);
        i0.ɵɵelementStart(29, "div");
        i0.ɵɵelementStart(30, "strong");
        i0.ɵɵtext(31);
        i0.ɵɵpipe(32, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(33);
        i0.ɵɵpipe(34, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(35, FFAMatchInformationPubgComponent_div_35_Template, 3, 2, "div", 9);
        i0.ɵɵtext(36);
        i0.ɵɵpipe(37, "translate");
        i0.ɵɵelementStart(38, "small", 10);
        i0.ɵɵtext(39);
        i0.ɵɵpipe(40, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(41, " \u2013 ");
        i0.ɵɵelementStart(42, "small", 10);
        i0.ɵɵtext(43);
        i0.ɵɵpipe(44, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("state", ctx.state)("startTime", ctx.startTime);
        i0.ɵɵadvance(5);
        i0.ɵɵstyleProp("width", 32, "px")("height", 32, "px");
        i0.ɵɵproperty("icon", ctx.mode);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 28, "ffa-match-information-pubg:mode-title"));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 30, "ffa-match-information-pubg:mode-" + ctx.mode), " ");
        i0.ɵɵadvance(5);
        i0.ɵɵstyleProp("width", 32, "px")("height", 32, "px");
        i0.ɵɵproperty("icon", ctx.weather);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 32, "ffa-match-information-pubg:weather-title"));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 34, "ffa-match-information-pubg:weather-" + ctx.weather), " ");
        i0.ɵɵadvance(5);
        i0.ɵɵstyleProp("width", 32, "px")("height", 32, "px");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(50, _c0$2, !ctx.redzoneEnabled, ctx.redzoneEnabled))("icon", "circle");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(32, 36, "ffa-match-information-pubg:redzone-title"));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(34, 38, "ffa-match-information-pubg:redzone-enabled", i0.ɵɵpureFunction1(53, _c1$1, ctx.redzoneEnabled ? 1 : 0)), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.lobbyName || ctx.lobbyPassword);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(37, 41, "ffa-match:match-number", i0.ɵɵpureFunction1(55, _c2$1, ctx.position)), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(40, 44, "ffa-match:round", i0.ɵɵpureFunction1(57, _c3$1, ctx.round)));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(44, 47, "ffa-match:group", i0.ɵɵpureFunction1(59, _c4, ctx.group + 1)));
    } }, directives: [i1.MatchInformationComponent, i4.SvgIconComponent, i5.NgClass, i5.NgIf, i4.ButtonComponent, i4.CopyToClipboardDirective], pipes: [i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
const ɵFFAMatchInformationPubgComponent_BaseFactory = /*@__PURE__*/ i0.ɵɵgetInheritedFactory(FFAMatchInformationPubgComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAMatchInformationPubgComponent, [{
        type: Component,
        args: [{
                selector: "ffa-match-information-pubg",
                templateUrl: "./ffa-match-information-pubg.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { mode: [{
            type: Input
        }], weather: [{
            type: Input
        }], redzoneEnabled: [{
            type: Input
        }], lobbyName: [{
            type: Input
        }], lobbyPassword: [{
            type: Input
        }] }); })();

const _c0$1 = function () { return { number: 1 }; };
const _c1 = function () { return { number: 2 }; };
const _c2 = function () { return { number: 3 }; };
const _c3 = function () { return { number: 4 }; };
class FfaMatchSkeletonComponent {
}
FfaMatchSkeletonComponent.ɵfac = function FfaMatchSkeletonComponent_Factory(t) { return new (t || FfaMatchSkeletonComponent)(); };
FfaMatchSkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FfaMatchSkeletonComponent, selectors: [["ffa-match-skeleton"]], decls: 47, vars: 32, consts: [[1, "u-baseline-tiny", "o-grid", "o-grid--inside"], [1, "c-ffa-match__match", "o-grid__item", "u-2/3", "u-baseline-small"], [1, "o-grid__item", "u-1/3", "u-baseline-small"], [1, "u-divided"], ["expansion-panel-header", "", 1, "o-grid", "o-grid--align-center", "o-grid--inside"], [1, "o-grid__item", "u-1/2"], [1, "o-grid__item", "u-2/4"], [3, "label"], [1, "c-skeleton__text", "c-skeleton__text--tiny", "c-skeleton__text--inline"]], template: function FfaMatchSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 0);
        i0.ɵɵelementStart(1, "match-information-skeleton", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "match-media-skeleton", 2);
        i0.ɵɵelementStart(5, "ranking-match-skeleton", 2);
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "ranking-match-skeleton", 2);
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "ranking-match-skeleton", 2);
        i0.ɵɵtext(12);
        i0.ɵɵpipe(13, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "section");
        i0.ɵɵelementStart(15, "expansion-panel", 3);
        i0.ɵɵelementStart(16, "div", 4);
        i0.ɵɵelementStart(17, "div", 5);
        i0.ɵɵelement(18, "ranking-contestant-skeleton");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 6);
        i0.ɵɵelementStart(20, "labeled-value", 7);
        i0.ɵɵpipe(21, "translate");
        i0.ɵɵelement(22, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "expansion-panel", 3);
        i0.ɵɵelementStart(24, "div", 4);
        i0.ɵɵelementStart(25, "div", 5);
        i0.ɵɵelement(26, "ranking-contestant-skeleton");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 6);
        i0.ɵɵelementStart(28, "labeled-value", 7);
        i0.ɵɵpipe(29, "translate");
        i0.ɵɵelement(30, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "expansion-panel", 3);
        i0.ɵɵelementStart(32, "div", 4);
        i0.ɵɵelementStart(33, "div", 5);
        i0.ɵɵelement(34, "ranking-contestant-skeleton");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "div", 6);
        i0.ɵɵelementStart(36, "labeled-value", 7);
        i0.ɵɵpipe(37, "translate");
        i0.ɵɵelement(38, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "expansion-panel", 3);
        i0.ɵɵelementStart(40, "div", 4);
        i0.ɵɵelementStart(41, "div", 5);
        i0.ɵɵelement(42, "ranking-contestant-skeleton");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "div", 6);
        i0.ɵɵelementStart(44, "labeled-value", 7);
        i0.ɵɵpipe(45, "translate");
        i0.ɵɵelement(46, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 8, "ffa-match:match-number", i0.ɵɵpureFunction0(28, _c0$1)), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 11, "ffa-match:match-number", i0.ɵɵpureFunction0(29, _c1)), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(10, 14, "ffa-match:match-number", i0.ɵɵpureFunction0(30, _c2)), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(13, 17, "ffa-match:match-number", i0.ɵɵpureFunction0(31, _c3)), " ");
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("label", i0.ɵɵpipeBind1(21, 20, "ffa-ranking:total-points"));
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("label", i0.ɵɵpipeBind1(29, 22, "ffa-ranking:total-points"));
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("label", i0.ɵɵpipeBind1(37, 24, "ffa-ranking:total-points"));
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("label", i0.ɵɵpipeBind1(45, 26, "ffa-ranking:total-points"));
    } }, directives: [i1.MatchInformationSkeletonComponent, i2$1.MatchMediaSkeletonComponent, i3.RankingMatchSkeletonComponent, i4.ExpansionPanelComponent, i3.RankingContestantSkeletonComponent, i4.LabeledValueComponent], pipes: [i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FfaMatchSkeletonComponent, [{
        type: Component,
        args: [{
                selector: "ffa-match-skeleton",
                templateUrl: "./ffa-match-skeleton.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

function FfaMatchComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function FfaMatchComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function FfaMatchComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function FfaMatchComponent_ng_template_6_article_0_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "p", 19);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 20);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "svg-icon", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 7, "ffa-match:autochess-join-title"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 9, "ffa-match:autochess-join-subtitle"));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("width", 50, "px")("height", 50, "px");
    i0.ɵɵproperty("icon", "chevron-right");
} }
function FfaMatchComponent_ng_template_6_article_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "p", 19);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 20);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "ffa-match:pubgm-join-title"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 4, "ffa-match:pubgm-join-subtitle"));
} }
function FfaMatchComponent_ng_template_6_article_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function FfaMatchComponent_ng_template_6_article_0_ng_template_9_ffa_match_information_pubg_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ffa-match-information-pubg", 24);
} if (rf & 2) {
    const matchSettings_r23 = ctx.ngIf;
    const match_r11 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("state", match_r11.state)("startTime", match_r11.beginAt)("round", match_r11.round)("group", match_r11.group)("position", match_r11.position)("mode", matchSettings_r23.entry.mode)("weather", matchSettings_r23.entry.weather)("redzoneEnabled", matchSettings_r23.entry.redzone)("lobbyName", matchSettings_r23.entry.lobby == null ? null : matchSettings_r23.entry.lobby.name)("lobbyPassword", matchSettings_r23.entry.lobby == null ? null : matchSettings_r23.entry.lobby.password);
} }
function FfaMatchComponent_ng_template_6_article_0_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FfaMatchComponent_ng_template_6_article_0_ng_template_9_ffa_match_information_pubg_0_Template, 1, 10, "ffa-match-information-pubg", 23);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r16.matchSettings$));
} }
function FfaMatchComponent_ng_template_6_article_0_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ffa-match-information", 25);
} if (rf & 2) {
    const match_r11 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("state", match_r11.state)("startTime", match_r11.beginAt)("round", match_r11.round)("group", match_r11.group)("position", match_r11.position);
} }
function FfaMatchComponent_ng_template_6_article_0_div_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function FfaMatchComponent_ng_template_6_article_0_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, FfaMatchComponent_ng_template_6_article_0_div_13_ng_container_1_Template, 1, 0, "ng-container", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r19.customActionTemplate);
} }
const _c0 = function (a0) { return { number: a0 }; };
function FfaMatchComponent_ng_template_6_article_0_ranking_match_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ranking-match", 28);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const entry_r27 = ctx.$implicit;
    i0.ɵɵproperty("link", i0.ɵɵpipeBind1(1, 4, entry_r27.link$))("state", i0.ɵɵpipeBind1(2, 6, "commons:match-state-" + entry_r27.match.state))("startTime", entry_r27.startTime);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 8, "ffa-match:match-number", i0.ɵɵpureFunction1(11, _c0, entry_r27.match.position)), " ");
} }
function FfaMatchComponent_ng_template_6_article_0_ffa_ranking_entry_18_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ffa-ranking-entry", 29);
    i0.ɵɵlistener("expansionChanged", function FfaMatchComponent_ng_template_6_article_0_ffa_ranking_entry_18_Template_ffa_ranking_entry_expansionChanged_0_listener($event) { i0.ɵɵrestoreView(_r31); const entry_r29 = ctx.$implicit; const ctx_r30 = i0.ɵɵnextContext(3); return ctx_r30.expansionChanged($event, entry_r29.contestant.id); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const entry_r29 = ctx.$implicit;
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("expandable", i0.ɵɵpipeBind1(1, 5, ctx_r21.leagueMode$) === 0)("isExpanded", entry_r29.isExpanded)("contestant", entry_r29.contestant)("members", i0.ɵɵpipeBind1(2, 7, entry_r29.members$))("integration", i0.ɵɵpipeBind1(3, 9, ctx_r21.league$).entry.gameIntegration);
} }
function FfaMatchComponent_ng_template_6_article_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "article", 6);
    i0.ɵɵelementStart(1, "section", 7);
    i0.ɵɵtemplate(2, FfaMatchComponent_ng_template_6_article_0_a_2_Template, 9, 11, "a", 8);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, FfaMatchComponent_ng_template_6_article_0_div_5_Template, 8, 6, "div", 9);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵtemplate(7, FfaMatchComponent_ng_template_6_article_0_ng_container_7_Template, 1, 0, "ng-container", 10);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtemplate(9, FfaMatchComponent_ng_template_6_article_0_ng_template_9_Template, 2, 3, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(11, FfaMatchComponent_ng_template_6_article_0_ng_template_11_Template, 1, 5, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(13, FfaMatchComponent_ng_template_6_article_0_div_13_Template, 2, 1, "div", 13);
    i0.ɵɵelement(14, "match-media", 14);
    i0.ɵɵtemplate(15, FfaMatchComponent_ng_template_6_article_0_ranking_match_15_Template, 5, 13, "ranking-match", 15);
    i0.ɵɵpipe(16, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "section");
    i0.ɵɵtemplate(18, FfaMatchComponent_ng_template_6_article_0_ffa_ranking_entry_18_Template, 4, 11, "ffa-ranking-entry", 16);
    i0.ɵɵpipe(19, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r15 = i0.ɵɵreference(10);
    const _r17 = i0.ɵɵreference(12);
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r9.customActionTemplate && i0.ɵɵpipeBind1(3, 11, ctx_r9.isAutochess$) && i0.ɵɵpipeBind1(4, 13, ctx_r9.userContestants$).length > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r9.customActionTemplate && i0.ɵɵpipeBind1(6, 15, ctx_r9.isPUBGM$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 17, ctx_r9.isPUBG$))("ngIfThen", _r15)("ngIfElse", _r17);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r9.customActionTemplate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matchId", ctx_r9.matchId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(16, 19, ctx_r9.groupMatchEntries$))("ngForTrackBy", ctx_r9.trackMatchEntries);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(19, 21, ctx_r9.rankingEntries$))("ngForTrackBy", ctx_r9.trackRankingEntries);
} }
function FfaMatchComponent_ng_template_6_match_not_found_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "match-not-found");
} }
function FfaMatchComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FfaMatchComponent_ng_template_6_article_0_Template, 20, 23, "article", 4);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtemplate(2, FfaMatchComponent_ng_template_6_match_not_found_2_Template, 1, 0, "match-not-found", 5);
    i0.ɵɵpipe(3, "async");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx_r4.match$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(3, 4, ctx_r4.match$));
} }
function FfaMatchComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ffa-match-skeleton");
} }
function FfaMatchComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"));
} }
var LeagueMode;
(function (LeagueMode) {
    LeagueMode[LeagueMode["Team"] = 0] = "Team";
    LeagueMode[LeagueMode["Solo"] = 1] = "Solo";
})(LeagueMode || (LeagueMode = {}));
class FfaMatchComponent {
    constructor(store, rankingContestantService, matchContestantService, rankingGroupService, formatDate, linkService, metadataServices, rankingMemberTexts) {
        this.store = store;
        this.rankingContestantService = rankingContestantService;
        this.matchContestantService = matchContestantService;
        this.rankingGroupService = rankingGroupService;
        this.formatDate = formatDate;
        this.linkService = linkService;
        this.metadataServices = metadataServices;
        this.rankingMemberTexts = rankingMemberTexts;
        this.expanded = false;
    }
    getGIServices(league) {
        const byGI = service => {
            if (!league.gameIntegration) {
                return service.integration === null;
            }
            return hasIntegration(league, `gameintegration${service.integration}`);
        };
        const metadata = this.metadataServices.find(byGI);
        const text = this.rankingMemberTexts.find(byGI);
        return { text, metadata };
    }
    /**
     * Initialize observables
     */
    ngOnInit() {
        this.user$ = this.store.select(getUser).pipe(filter(entryAvailable));
        this.userContestants$ = this.user$.pipe(switchMap(user => {
            this.store.dispatch(new LoadContestantsOnceAction(this.leagueId, +user.entry.id));
            return this.store.select(getContestants(this.leagueId, +user.entry.id));
        }), filter(entryAvailable), map(contestants => contestants.entry));
        // Preload for match media upload
        this.store.dispatch(new LoadMediaOnceAction(this.matchId));
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId)).pipe(filter(entryAvailable));
        this.isPUBG$ = this.league$.pipe(filter(entryAvailable), map(league => hasIntegration(league.entry, "gameintegrationpubg")));
        this.isAutochess$ = this.league$.pipe(filter(entryAvailable), map(league => hasIntegration(league.entry, "gameintegrationautochess")));
        this.isPUBGM$ = this.league$.pipe(filter(entryAvailable), map(league => hasIntegration(league.entry, "gameintegrationpubgmobile")));
        this.leagueMode$ = this.league$.pipe(distinct(league => {
            if (isTeam(league.entry)) {
                return LeagueMode.Team;
            }
            return LeagueMode.Solo;
        }));
        this.store.dispatch(new LoadLeagueResultsAction(this.leagueId));
        this.results$ = this.store.select(getLeagueResults(this.leagueId)).pipe(filter(exists));
        this.match$ = this.results$.pipe(filter(entryAvailable), map(results => find(results.entry, result => result.id === this.matchId)));
        this.gameaccounts$ = this.match$.pipe(filter(exists), switchMap(match => {
            const matchId = match.id;
            this.store.dispatch(new LoadMatchOnceAction(matchId));
            return this.store.select(getMatch(matchId));
        }), filter(entryAvailable), map(match => match.entry.gameaccounts), startWith({}));
        this.matchMetaData$ = combineLatest(this.match$, this.league$.pipe(filter(entryAvailable))).pipe(switchMap(([match, league]) => {
            const { metadata } = this.getGIServices(league.entry);
            if (!metadata) {
                return null;
            }
            return metadata.getMetaData([match]);
        }));
        this.matchSettings$ = this.isPUBG$.pipe(switchMap(isPUBG => {
            if (isPUBG) {
                this.store.dispatch(new LoadPubgMatchSettingsOnceAction(this.matchId));
                return this.store.select(getPubgMatchSettings(this.matchId));
            }
            return of({ loading: false, entry: null, error: null });
        }));
        this.groupMatchEntries$ = this.getGroupMatches().pipe(map(matches => matches.map(match => ({
            link$: this.getMatchLink(match.id),
            startTime: match.beginAt,
            match: match,
        }))));
        this.rankingEntries$ = this.getGroupContestants().pipe(map(contestants => contestants.map(contestant => ({
            contestant: contestant,
            members$: this.getMembers(contestant.id),
            isExpanded: this.isExpanded(contestant),
        }))));
        this.isLoading$ = this.getIsLoading();
        this.hasError$ = this.getHasError();
        this.isReady$ = this.getIsReady();
    }
    getMatchLink(matchId) {
        return this.league$.pipe(filter(entryAvailable), map(league => {
            return this.linkService.match(league.entry.uri, matchId);
        }));
    }
    /**
     * @param playerIds
     */
    getPlayerContestants(playerIds, gameaccounts) {
        if (playerIds.length) {
            this.store.dispatch(new LoadPlayersOnceAction(playerIds));
        }
        const participants$ = playerIds.map(playerId => {
            return this.store.select(getPlayer(playerId)).pipe(filter(exists), map(player => ({ id: playerId, data: player })));
        });
        return combineLatest(participants$).pipe(map(players => {
            return players.map(player => this.rankingContestantService.getRankingContestantFromPlayer(player.id, player.data.entry, gameaccounts[player.id]));
        }));
    }
    /**
     * @param teamIds
     */
    getTeamContestants(teamIds, league) {
        if (teamIds.length) {
            this.store.dispatch(new LoadTeamsOnceAction(teamIds));
        }
        const participants$ = teamIds.map(teamId => {
            return this.store.select(getTeam(teamId)).pipe(filter(exists), map(team => ({ id: teamId, data: team })));
        });
        return combineLatest(participants$).pipe(map(teams => {
            return teams.map(team => this.rankingContestantService.getRankingContestantFromTeam(isRosterEnabled(league), league.uri, team.id, team.data.entry));
        }));
    }
    /**
     * Handler for lazy loading the expansion panel data when it opens/closes
     *
     * @param state
     * @param contestantId
     */
    expansionChanged(state, contestantId) {
        this.leagueMode$.pipe(first()).subscribe(leagueMode => {
            if (state === ExpansionState.OPEN && leagueMode === LeagueMode.Team) {
                this.store.dispatch(new LoadRosterOnceAction(this.leagueId, contestantId));
                this.store.dispatch(new LoadMembersOnceAction(contestantId));
            }
        });
    }
    /**
     * @param contestant
     */
    isExpanded(contestant) {
        if (this.expanded) {
            return;
        }
        if (contestant.rank === 1) {
            this.expansionChanged(ExpansionState.OPEN, contestant.id);
            this.expanded = true;
        }
        return contestant.rank === 1;
    }
    /**
     * Builds the teammates to be ready for displaying
     *
     * @param metaData
     * @param roster
     * @param members
     */
    buildTeamMembers(metaData, roster, members, league, gameaccounts) {
        const { text } = this.getGIServices(league);
        return members.reduce((entryArray, teamMember) => {
            if (roster.members.indexOf(+teamMember.user.id) === -1) {
                return entryArray;
            }
            const rankingContestant = this.rankingContestantService.getRankingContestantFromPlayer(+teamMember.user.id, teamMember.user, gameaccounts[teamMember.user.id]);
            const rankingMember = text.getRankingMember(rankingContestant, metaData);
            return [...entryArray, rankingMember];
        }, []);
    }
    /**
     * Get the team members for the expanded expansion panel
     *
     * @param teamId
     */
    getMembers(teamId) {
        const members$ = this.store.select(getTeamMembers(teamId)).pipe(filter(exists));
        const roster$ = this.store.select(getRoster(this.leagueId, teamId)).pipe(filter(exists));
        return this.leagueMode$.pipe(switchMap(leagueMode => {
            if (leagueMode === LeagueMode.Solo) {
                return [];
            }
            return combineLatest(members$, roster$, this.league$, this.matchMetaData$, this.gameaccounts$);
        }), map(([members, roster, league, metaData, gameaccounts]) => {
            const rosterCount = roster.entry ? roster.entry.members.length : league.entry.teamSize;
            if (!members.entry || !roster.entry) {
                return Object.assign(Object.assign({}, members), { entry: {
                        count: rosterCount,
                        members: [],
                    } });
            }
            const entries = this.buildTeamMembers(metaData, roster.entry, members.entry, league.entry, gameaccounts);
            return Object.assign(Object.assign({}, members), { entry: {
                    count: rosterCount,
                    members: entries,
                } });
        }));
    }
    getIsReady() {
        return combineLatest(this.isLoading$, this.hasError$).pipe(map(([loading, error]) => Boolean(!loading && !error)));
    }
    getHasError() {
        return combineLatest(this.league$, this.results$, this.matchSettings$).pipe(map(data => {
            return data.filter(entry => Boolean(entry && entry.error)).length > 0;
        }));
    }
    getIsLoading() {
        return combineLatest(this.league$, this.results$, this.matchSettings$).pipe(map(data => {
            return data.filter(entry => Boolean(!entry || (entry.loading && !entry.entry))).length !== 0;
        }));
    }
    getGroupMatches() {
        return combineLatest(this.results$.pipe(filter(entryAvailable)), this.match$).pipe(map(([results, match]) => {
            if (!match) {
                return [];
            }
            const group = {
                group: match.group,
                round: match.round,
            };
            return this.rankingGroupService
                .getGroupMatchesFromResults(results.entry, group)
                .filter(result => result.id !== this.matchId);
        }));
    }
    getGroupContestants() {
        const contestants$ = combineLatest(this.match$, this.league$, this.gameaccounts$).pipe(filter(exists), switchMap(([match, league, gameaccounts]) => {
            const contestantIds = match.participants.map(participant => participant.id);
            return isPlayer(league.entry)
                ? this.getPlayerContestants(contestantIds, gameaccounts)
                : this.getTeamContestants(contestantIds, league.entry);
        }));
        return combineLatest(this.results$.pipe(filter(entryAvailable)), contestants$).pipe(map(([results, contestants]) => {
            const rankingContestants = contestants.map(contestant => {
                return this.matchContestantService.getRankedContestant(this.matchId, contestant, results.entry);
            });
            return sortBy(rankingContestants, contestant => {
                if (contestant.rank === 0) {
                    return 1000000; // just so that we group them at the bottom
                }
                return contestant.rank;
            });
        }));
    }
    trackRankingEntries(index, item) {
        return item.contestant.id;
    }
    trackMatchEntries(index, item) {
        return item.match.id;
    }
}
FfaMatchComponent.ɵfac = function FfaMatchComponent_Factory(t) { return new (t || FfaMatchComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i2$2.RankingContestantService), i0.ɵɵdirectiveInject(MatchContestantService), i0.ɵɵdirectiveInject(i2$2.RankingGroupService), i0.ɵɵdirectiveInject(i4.FormatDate), i0.ɵɵdirectiveInject(i4.LinkService), i0.ɵɵdirectiveInject(MATCH_METADATA), i0.ɵɵdirectiveInject(RANKING_MEMBER_TEXTS)); };
FfaMatchComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FfaMatchComponent, selectors: [["ffa-match"]], inputs: { leagueId: "leagueId", matchId: "matchId", customActionTemplate: "customActionTemplate" }, decls: 12, vars: 12, consts: [[4, "ngIf", "ngIfThen"], ["ready", ""], ["loading", ""], ["error", ""], ["class", "c-ffa-match", 4, "ngIf"], [4, "ngIf"], [1, "c-ffa-match"], [1, "u-baseline-tiny", "o-grid", "o-grid--inside"], ["class", "o-grid__item c-ffa-match__banner-join c-ffa-match__banner-join--autochess u-baseline-small no-decoration", "href", "https://play.eslgaming.com/banner/global/how-to-play", "target", "_blank", 4, "ngIf"], ["class", "o-grid__item c-ffa-match__banner-join c-ffa-match__banner-join--pubgm u-baseline-small no-decoration", 4, "ngIf"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["pubg", ""], ["simple", ""], ["class", "c-ffa-match__action u-baseline-smaller", 4, "ngIf"], [1, "o-grid__item", "u-1/3", "u-baseline-small", 3, "matchId"], ["class", "o-grid__item u-1/3 c-ffa-match__match u-baseline-small", 3, "link", "state", "startTime", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "u-divided", 3, "expandable", "isExpanded", "contestant", "members", "integration", "expansionChanged", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["href", "https://play.eslgaming.com/banner/global/how-to-play", "target", "_blank", 1, "o-grid__item", "c-ffa-match__banner-join", "c-ffa-match__banner-join--autochess", "u-baseline-small", "no-decoration"], [1, "c-ffa-match__banner-join__information"], [1, "c-ffa-match__banner-join__title"], [1, "c-ffa-match__banner-join__subtitle"], [1, "c-ffa-match__banner-join__chevron", 3, "icon"], [1, "o-grid__item", "c-ffa-match__banner-join", "c-ffa-match__banner-join--pubgm", "u-baseline-small", "no-decoration"], ["class", "c-ffa-match__match o-grid__item u-2/3 u-baseline-small", 3, "state", "startTime", "round", "group", "position", "mode", "weather", "redzoneEnabled", "lobbyName", "lobbyPassword", 4, "ngIf"], [1, "c-ffa-match__match", "o-grid__item", "u-2/3", "u-baseline-small", 3, "state", "startTime", "round", "group", "position", "mode", "weather", "redzoneEnabled", "lobbyName", "lobbyPassword"], [1, "c-ffa-match__match", "o-grid__item", "u-2/3", "u-baseline-small", 3, "state", "startTime", "round", "group", "position"], [1, "c-ffa-match__action", "u-baseline-smaller"], [4, "ngTemplateOutlet"], [1, "o-grid__item", "u-1/3", "c-ffa-match__match", "u-baseline-small", 3, "link", "state", "startTime"], [1, "u-divided", 3, "expandable", "isExpanded", "contestant", "members", "integration", "expansionChanged"]], template: function FfaMatchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FfaMatchComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, FfaMatchComponent_ng_container_2_Template, 1, 0, "ng-container", 0);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵtemplate(4, FfaMatchComponent_ng_container_4_Template, 1, 0, "ng-container", 0);
        i0.ɵɵpipe(5, "async");
        i0.ɵɵtemplate(6, FfaMatchComponent_ng_template_6_Template, 4, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(8, FfaMatchComponent_ng_template_8_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(10, FfaMatchComponent_ng_template_10_Template, 3, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(7);
        const _r5 = i0.ɵɵreference(9);
        const _r7 = i0.ɵɵreference(11);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 6, ctx.isReady$))("ngIfThen", _r3);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 8, ctx.isLoading$))("ngIfThen", _r5);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 10, ctx.hasError$))("ngIfThen", _r7);
    } }, directives: [i5.NgIf, i2$1.MatchMediaComponent, i5.NgForOf, i4.SvgIconComponent, FFAMatchInformationPubgComponent, FFAMatchInformationComponent, i5.NgTemplateOutlet, i3.RankingMatchComponent, i2$2.FfaRankingEntryComponent, i1.MatchNotFoundComponent, FfaMatchSkeletonComponent, i4.InlineErrorComponent], pipes: [i5.AsyncPipe, i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FfaMatchComponent, [{
        type: Component,
        args: [{
                selector: "ffa-match",
                templateUrl: "./ffa-match.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2$2.RankingContestantService }, { type: MatchContestantService }, { type: i2$2.RankingGroupService }, { type: i4.FormatDate }, { type: i4.LinkService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MATCH_METADATA]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [RANKING_MEMBER_TEXTS]
            }] }]; }, { leagueId: [{
            type: Input
        }], matchId: [{
            type: Input
        }], customActionTemplate: [{
            type: Input
        }] }); })();

const ffaMatchTexts = {
    "ffa-match:match-number": "Match #{number}",
    "ffa-match:round": "Round {round}",
    "ffa-match:group": "Group {group}",
    "ffa-match:autochess-join-title": "You need to use the ESL Play App to join this match.",
    "ffa-match:autochess-join-subtitle": "Click here for more information/to find more",
    "ffa-ranking:total-points": "Total Points",
    "ffa-ranking:tiebreaker-points": "Kill Points",
    "commons:match-state-open": "open",
    "commons:match-state-exception": "exception",
    "commons:match-state-deleted": "deleted",
    "commons:match-state-closed": "closed",
    // Implizit needed translations
    "commons:enter-result": "enter",
    "commons:protest-match": "protest",
    "commons:members": "members",
};

const matchInformationPubgTexts = {
    "ffa-match-information-pubg:mode-title": "play mode",
    "ffa-match-information-pubg:mode-TPP": "3rd Person",
    "ffa-match-information-pubg:mode-FPP": "1st Person",
    "ffa-match-information-pubg:weather-title": "weather",
    "ffa-match-information-pubg:weather-rainy": "rainy",
    "ffa-match-information-pubg:weather-foggy": "foggy",
    "ffa-match-information-pubg:weather-sunset": "sunset",
    "ffa-match-information-pubg:weather-sunny": "sunny",
    "ffa-match-information-pubg:redzone-title": "redzone",
    "ffa-match-information-pubg:redzone-enabled": "{enabled, select, 0{no redzone} other{with redzone}}",
    "ffa-match-information-pubg:lobby-name": "Lobby name",
    "ffa-match-information-pubg:lobby-password": "Lobby password",
    "commons:copy": "copy",
};

class FFAMatchModule {
}
FFAMatchModule.ɵfac = function FFAMatchModule_Factory(t) { return new (t || FFAMatchModule)(); };
FFAMatchModule.ɵmod = i0.ɵɵdefineNgModule({ type: FFAMatchModule });
FFAMatchModule.ɵinj = i0.ɵɵdefineInjector({ providers: [MatchContestantService], imports: [[
            CommonModule,
            CommonsLoadingModule,
            CommonsComponentModule,
            CommonsDateModule,
            TranslationModule,
            FFArankingModule,
            RankingComponentsModule,
            MatchModule,
            MatchMediaModule,
            CommonsErrorModule,
            StateModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FFAMatchModule, { declarations: [FfaMatchComponent, FfaMatchSkeletonComponent, FFAMatchInformationComponent, FFAMatchInformationPubgComponent], imports: [CommonModule,
        CommonsLoadingModule,
        CommonsComponentModule,
        CommonsDateModule,
        TranslationModule,
        FFArankingModule,
        RankingComponentsModule,
        MatchModule,
        MatchMediaModule,
        CommonsErrorModule,
        StateModule], exports: [FfaMatchComponent, FfaMatchSkeletonComponent, FFAMatchInformationComponent, FFAMatchInformationPubgComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAMatchModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    CommonsLoadingModule,
                    CommonsComponentModule,
                    CommonsDateModule,
                    TranslationModule,
                    FFArankingModule,
                    RankingComponentsModule,
                    MatchModule,
                    MatchMediaModule,
                    CommonsErrorModule,
                    StateModule,
                ],
                declarations: [FfaMatchComponent, FfaMatchSkeletonComponent, FFAMatchInformationComponent, FFAMatchInformationPubgComponent],
                exports: [FfaMatchComponent, FfaMatchSkeletonComponent, FFAMatchInformationComponent, FFAMatchInformationPubgComponent],
                providers: [MatchContestantService],
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { FFAMatchInformationComponent, FFAMatchInformationPubgComponent, FFAMatchModule, FfaMatchComponent, FfaMatchSkeletonComponent, MatchContestantService, ffaMatchTexts, matchInformationPubgTexts };
//# sourceMappingURL=play-match-ffa.js.map
